import React from 'react';
import {connect} from 'react-redux';

import {updateObject} from 'utils/reducerUtils';
import strings from 'utils/strings';

import classNames from 'classnames';
import AudioPlayer from 'components/AudioPlayer';

import previewVideo from './assets/tutorial.mp4';

import introNo from 'assets/sounds/no/Ordkjedetest_eksempler-start.m4a';
import introNn from 'assets/sounds/nn/2 2 Ordkjedetest-her-ser-du-4-ovingsoppgaver.mp3';
import correctAnswer from 'assets/sounds/no/Ordkjedetest_eksempler-correctAnswer.m4a';
import starterTestenNo from 'assets/sounds/no/Trykk-Starter-testen.mp3';
import starterTestenNn from 'assets/sounds/nn/2 7 Ordkjedetest-Starter-testen.mp3';

import assignmentsNo from './data/tutorial-no';
import assignmentsNn from './data/tutorial-nn';

const languages = {
  no: {
    intro: introNo,
    starterTesten: starterTestenNo,
    assignments: assignmentsNo,
    correctAnswer: correctAnswer,
  },
  nn: {
    intro: introNn,
    starterTesten: starterTestenNn,
    assignments: assignmentsNn,
    correctAnswer: correctAnswer,
  },
};

const whiteSpaceRegex = /\s+/g;

const stripWhiteSpace = (str) => str.replace(whiteSpaceRegex, '');
const removeDuplicateWhiteSpace = (str) => str.replace(whiteSpaceRegex, ' ');
const getNumberOfWhiteSpaces = (str) => {
  const matches = str.match(whiteSpaceRegex);
  return matches ? matches.length : 0;
};

const WHITE_SPACE_LIMIT = 3;
const isAttempted = (value) => getNumberOfWhiteSpaces(value) === WHITE_SPACE_LIMIT;

class Test extends React.Component {
  constructor(props) {
    super(props);

    const assets = languages[strings.getLanguage()];

    this.starterTestenSound = assets.starterTesten;
    this.audio = assets.intro;
    this.correctAnswerSound = assets.correctAnswer;
    this.assignments = assets.assignments;
    this.ordkjedetestTutorial = this.props.isNorming ? strings.ordkjedetestTutorialNorming : strings.ordkjedetestTutorial;

    this.audioRefs = {};

    const results = {};
    for (const assignment of this.assignments) {
      results[assignment.id] = assignment.text;
    }

    this.state = {
  results,
  lastCompletedId: null,
  deferFinalVO: false,  
  playFinalTick: 0,     
  showNextBtn:!this.props.isNorming,
};
  }

  setResults(id, value) {
    const { results } = this.state;
    this.setState({
      results: updateObject(results, { [id]: value }),
    });
  }

  render() {
    const { onNextStep } = this.props;
    const { results } = this.state;


    let allAssignmentsCompleted = true;
    for (const id in results) {
      if (Object.prototype.hasOwnProperty.call(results, id)) {
        if (!isAttempted(results[id])) {
          allAssignmentsCompleted = false;
          break;
        }
      }
    }

    let videoRef;

    return (
      <div className="lit-test lit-word-chain">
        <p>
          <AudioPlayer
            autoplay
            inline
            onErrorPlay={() => {
              console.log('Something went wrong');
            }}
            onPause={() => {
              videoRef && videoRef.play();
            }}
            refs={this.audioRefs}
            src={this.audio}
          />
          {this.ordkjedetestTutorial}
        </p>

        <div className="lit-preview">
          <p className="lit-preview__label">{strings.howTo}</p>
          <video
            className="lit-preview__video"
            onClick={() => {
              videoRef && videoRef.play();
            }}
            ref={(ref) => {
              videoRef = ref;
            }}
            src={previewVideo}
          />
        </div>

        <div className="lit-wrapper--thin tutorial">
          <div className="lit-word-chains">
          {this.assignments.map((assignment, i) => {
  const { answer, count, id, text, audio,answer2 } = assignment;

  const value = results[id];
  const attempted = isAttempted(value);
  const accepted = [answer, answer2].filter(Boolean);
  const isCorrect = attempted && accepted.some(a => value === a);


  const prevAttempted = i === 0 ? true : isAttempted(results[this.assignments[i - 1].id]);
  const isDisabled = i > 0 && !prevAttempted;

const onChange = (ev) => {
  const next = removeDuplicateWhiteSpace(ev.target.value.trim());

  const hasUserEnteredOtherCharacters = stripWhiteSpace(next) !== text;
  const numberOfWhiteSpaces = getNumberOfWhiteSpaces(next);
  if (hasUserEnteredOtherCharacters || numberOfWhiteSpaces > WHITE_SPACE_LIMIT) return;


  const prevAttempted = isAttempted(this.state.results[id]);
  const nextAttempted = isAttempted(next);

  this.setState((prev) => ({
    results: updateObject(prev.results, { [id]: next }),
    ...( !prevAttempted && nextAttempted
        ? { lastCompletedId: id, deferFinalVO: true }
        : null ),
  }));
};


  const onFocus = () => {
    if (isDisabled) return;
    const inputElement = document.getElementById(`wc-${i}`);
    setTimeout(() => {
      if (inputElement) {
        inputElement.focus();
        inputElement.setSelectionRange(0, 0);
      }
    }, 0);
  };


  const shouldShowFeedback = attempted && i > 0;
  const isLastCompleted = this.state.lastCompletedId === id;
const handleFeedbackEnded = () => {
  if (isLastCompleted) {
    this.setState((prev) => ({
      deferFinalVO: false,
      playFinalTick: prev.playFinalTick + 1, 
    }));
  }
};
  return (
    <div className="input-wrapper" key={id}>
      <div
        className={classNames('lit-input', 'inline', {
          completed: attempted,
          disabled: isDisabled,
        })}
      >
        <label className="lit-input__label tiny lit-input__label--count">
          {id}
        </label>

        <input
          id={`wc-${i}`}
          autoFocus={i === 0}
          className="lit-input__field"
          onChange={onChange}
          onFocus={onFocus}
          spellCheck={false}
          value={value}
          disabled={isDisabled}
          aria-disabled={isDisabled}
          tabIndex={isDisabled ? -1 : 0}
        />
      </div>

      {shouldShowFeedback && (
        <p className="comment">
          {isCorrect ? (
            <span>
              {this.props.isNorming && (
                <AudioPlayer
                  inline
                  autoplay
                  preload="auto"
                  refs={this.audioRefs}
                  src={this.correctAnswerSound}
				onPause={handleFeedbackEnded} 
                />
              )}
              {strings.ordkjedeHeltRiktig}
            </span>
          ) : (
            <span>
              <AudioPlayer
                inline
                autoplay
                onErrorPlay={() => { console.log('Something went wrong'); }}
                   refs={this.audioRefs}
					src={audio}
					onEnded={handleFeedbackEnded}
					onPause={handleFeedbackEnded} 
              />
              {strings.formatString(strings.ordkjedeIkkeRiktig, count)}{' '}
              <strong>{answer.split(' ').join(', ')}</strong>
            </span>
          )}
        </p>
      )}
    </div>
  );
})}

          </div>

         
          {allAssignmentsCompleted && (
            <p className="instruction">
              <AudioPlayer
			   key={`final-${this.state.playFinalTick}`}
                autoplay
                onErrorPlay={() => {
                  console.log('Something went wrong');
                }}
                inline
				onComplete={()=>{
					this.setState({
						showNextBtn:true
					});
				}}
                refs={this.audioRefs}
                src={this.starterTestenSound}
              />
              {strings.ordkjedeStarterTesten}
            </p>
          )}

          {allAssignmentsCompleted && this.state.showNextBtn && (
            <button
              className="lit-btn bg-primary"
              onClick={() => {
                onNextStep(this.state.results);
                this.props.onShowAvatar(false);
              }}
            >
              {strings.start}
            </button>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({});
export default connect(mapStateToProps)(Test);
